/**
 * The own-scenarios form of FutureScenariosAdmin (#1062). Pure.
 * A row is { key, id?, title, level ('' | '1'..'9'), text }.
 */
let seq = 0;
const key = () => `row-${Date.now().toString(36)}-${(seq += 1)}`;

export const toRows = (scenarios = []) => scenarios.map((s) => ({
  key: key(), id: s.id, title: s.title || '', level: s.level != null ? String(s.level) : '', text: s.text || '',
}));

export const newRow = () => ({ key: key(), title: '', level: '', text: '' });

export const updateRow = (rows, k, patch) => rows.map((r) => (r.key === k ? { ...r, ...patch } : r));
export const removeRow = (rows, k) => rows.filter((r) => r.key !== k);

/** A scenario counts when it has a title and a text. */
export const usableRows = (rows) => rows.filter((r) => r.title.trim() && r.text.trim());

export const rowsToPayload = (rows) => usableRows(rows).map((r) => ({
  ...(r.id ? { id: r.id } : {}),
  title: r.title.trim(),
  text: r.text.trim(),
  level: r.level ? Number(r.level) : null,
}));

export const canSave = (rows, min) => usableRows(rows).length >= min;

export const isDirty = (rows, saved = []) => JSON.stringify(rowsToPayload(rows).map(({ id: _id, ...r }) => r))
  !== JSON.stringify(saved.map(({ id: _id, title, text, level }) => ({ title, text, level: level ?? null })));
